var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.18543 0.276735C8.99536 -0.0681565 8.49969 -0.0681564 8.30962 0.276735L0.0628104 15.2408C-0.120838 15.5741 0.120225 15.9821 0.500714 15.9821H16.9943C17.3748 15.9821 17.6159 15.574 17.4322 15.2408L9.18543 0.276735ZM9.43739 11.0172H8.05675L7.78578 7.54958L7.74707 4.98193H9.74707L9.70836 7.54958L9.43739 11.0172ZM9.74707 13.9819H7.74707V11.9305H9.74707V13.9819Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.34bd48a38d2baeb9e96d3fd83bd2c1bc.svg";
export { ForwardRef as ReactComponent };